var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinbookLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 80,
    viewBox: "0 0 194 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "14.416%",
    y1: "41.606%",
    x2: "134.123%",
    y2: "75.532%",
    id: "d8dcgk3jkc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#033898",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93F4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "85.558%",
    y1: "22.619%",
    x2: "28.176%",
    y2: "76.499%",
    id: "bhr75vx21d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93F4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5AE5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "81.509%",
    x2: "87.442%",
    y2: "34.141%",
    id: "ojkua0op0e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93F4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5AE5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-31%",
    y: "-25.9%",
    width: "162.1%",
    height: "162.1%",
    filterUnits: "objectBoundingBox",
    id: "6mhd2frhga"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.074847028 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "uyw5b83h7b",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    rx: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#323E48",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.4 30.528c.512 0 .8-.288.8-.8V26.4c0-.512-.288-.8-.8-.8H80.72c-.512 0-.8.288-.8.8v20.8c0 .512.288.8.8.8h3.52c.512 0 .8-.288.8-.8v-7.104h7.2c.512 0 .8-.288.8-.8v-3.328c0-.512-.288-.8-.8-.8h-7.2v-4.64h7.36zM96.62 30.08h3.2c.512 0 .8-.288.8-.8V26.4c0-.512-.288-.8-.8-.8h-3.2c-.512 0-.8.288-.8.8v2.88c0 .512.288.8.8.8zm0 17.92h3.2c.512 0 .8-.288.8-.8V32.8c0-.512-.288-.8-.8-.8h-3.2c-.512 0-.8.288-.8.8v14.4c0 .512.288.8.8.8zM113 31.552c-2.046 0-3.408.797-4.16 1.91V32.8c0-.512-.288-.8-.8-.8h-3.2c-.512 0-.8.288-.8.8v14.4c0 .512.288.8.8.8h3.2c.512 0 .8-.288.8-.8v-8.544c0-1.888.896-2.688 2.336-2.688 1.216 0 2.144.704 2.144 2.304V47.2c0 .512.288.8.8.8h3.2c.512 0 .8-.288.8-.8v-9.344c0-4-2.144-6.304-5.12-6.304zM130.692 31.552c-2.141 0-3.698.723-4.768 1.942V26.4c0-.512-.288-.8-.8-.8h-3.2c-.512 0-.8.288-.8.8v20.8c0 .512.288.8.8.8h3.2c.512 0 .8-.288.8-.8v-.694c1.07 1.22 2.627 1.942 4.768 1.942 4.192 0 7.648-3.68 7.648-8.448 0-4.768-3.456-8.448-7.648-8.448zm-.96 12.352c-2.208 0-3.808-1.504-3.808-3.904s1.6-3.904 3.808-3.904c2.208 0 3.808 1.504 3.808 3.904s-1.6 3.904-3.808 3.904zM148.64 48.448c4.704 0 8.48-3.68 8.48-8.448 0-4.768-3.776-8.448-8.48-8.448-4.704 0-8.48 3.68-8.48 8.448 0 4.768 3.776 8.448 8.48 8.448zm0-4.672c-2.08 0-3.68-1.504-3.68-3.776s1.6-3.776 3.68-3.776 3.68 1.504 3.68 3.776-1.6 3.776-3.68 3.776zM167.42 48.448c4.704 0 8.48-3.68 8.48-8.448 0-4.768-3.776-8.448-8.48-8.448-4.704 0-8.48 3.68-8.48 8.448 0 4.768 3.776 8.448 8.48 8.448zm0-4.672c-2.08 0-3.68-1.504-3.68-3.776s1.6-3.776 3.68-3.776 3.68 1.504 3.68 3.776-1.6 3.776-3.68 3.776zM192.856 47.04l-4.96-7.04 4.704-7.04c.352-.544.128-.96-.512-.96h-3.68c-.416 0-.736.16-.96.512l-4.128 6.44V26.4c0-.512-.288-.8-.8-.8h-3.2c-.512 0-.8.288-.8.8v20.8c0 .512.288.8.8.8h3.2c.512 0 .8-.288.8-.8v-6.217l4.448 6.505c.224.352.544.512.96.512h3.648c.64 0 .864-.416.48-.96z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 8)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#6mhd2frhga)",
    xlinkHref: "#uyw5b83h7b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#uyw5b83h7b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.97 20.712C9.978 21.62 17.6 16 17.6 16s-6.191-2.142-12.383-2.394c-6.19-.252-5.151 7.106-5.151 7.106s3.896-.907 6.904 0z",
    fill: "url(#d8dcgk3jkc)",
    transform: "translate(29 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6 24.034S1.248 26.712.208 36c0 0-3.41-17.835 17.392-20v8.034z",
    fill: "url(#bhr75vx21d)",
    transform: "translate(29 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 0v8.331S4.04 8.946.233 20.8C.233 20.8-4.037 1.342 24 0",
    fill: "url(#ojkua0op0e)",
    transform: "translate(29 22)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinbookLogo);
export default __webpack_public_path__ + "static/media/finbookLogo.9ac28bef1be9b889a6b274ee967e552a.svg";
export { ForwardRef as ReactComponent };